module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABCklEQVR42u3YPQqDQBCG4e0sdgvBA0RUPITnDKRa0qSNiCfTE3ypYshfp+zCvMI0U+nj7jerTpKzXKYfHgAAAAAAAAAAAAAAACTn3FkpSs6lqV8AIUR13STv43aD3h/TCyHmB9C2oySpaabthk+n+yG9vp/zA/A+qq5HhRBVlle17aSquh3Se66KhNf/DCiKi4Zh1rq+3t7evS0DcgIwvwLIgBQrICeAzwxYlu99vFcvy3MAGZAiA5gCGZ8DyABrU4BzABmQIAOYAnwL8Ecou28Bk/8EZe8CAIA3gFR7MZsMAMA6ACEIAFOAEASAKUAIAsAUIAQBAMDoGDRZAAAAAAAAAAAAAAAAYLQeaH2goIfBISIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/english_flag.png
// module id = 4IwS
// module chunks = 68